import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
//data inicial
const dataInicial = {
    loading: false,
    activo: false,
    data: {},
    fc_34: {},
    paginaActiva: 1,
    fc_34Map: {},
    modoVerDetalle:false,
    modoRecibidasCorregidas:false,
    modoProceso:false,
}

//types
const LOADING = 'LOADING'
const ACTUALIZAR_FC_34_PAGINA = 'ACTUALIZAR_FC_34_PAGINA'
const OBTENER_FC_34_DETALLE_EXITOAT = 'OBTENER_FC_34_DETALLE_EXITOAT'
const ACTUALIZAR_FC_34_ESTATUS_EXITO = 'ACTUALIZAR_FC_34_ESTATUS_EXITO'
const AGREGAR_FC_34_EXITO_MAP = 'AGREGAR_FC_34_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_34_MAP_EXITO = 'OBTENER_FC_34_MAP_EXITO'
const AGREGAR_FC_34_EXITO = 'AGREGAR_FC_34_EXITO'
const AGREGAR_FC_34_MAP_EXITO = 'AGREGAR_FC_34_MAP_EXITO'
const GENERAR_OFICIOS_FC34_EXITO = 'GENERAR_OFICIOS_FC34_EXITO'
const ACTUALIZAR_FC_34_SOLICITUD_MODAL_EXITO = 'ACTUALIZAR_FC_34_SOLICITUD_MODAL_EXITO'

//actions
export const obtenerFC_34SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_34_DETALLE_EXITOAT,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_34/obtenerFormatoFC34/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data[0]
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_34Estatus = createAsyncThunk(
    ACTUALIZAR_FC_34_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_34Solicitud = createAsyncThunk(
    AGREGAR_FC_34_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_34/actualizarFormatoFC34`
            const res = await axios.put(fullUrl, { data:data })
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarMapFC_34Accion = createAsyncThunk(
    AGREGAR_FC_34_EXITO_MAP,
    async (data) => {
        try {
            console.log("los datos de map es ", data)
            const agregarFC_34Map = host + `MapSolicitud/agregarMapFC_34_NotificacionSuspencionYReactivacionMap`
            const res = await axios.post(agregarFC_34Map, { data:data })
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerFC_34Map = createAsyncThunk(
    OBTENER_FC_34_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_34_NotificacionSuspencionYReactivacionMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            if (res != null) {
                return res.data.data
            } else {
                return {}
            }
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarFC_34MapSolicitud = createAsyncThunk(
    AGREGAR_FC_34_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `MapSolicitud/actualizarMapFC_34_NotificacionSuspencionYReactivacionMap`
            const res = await axios.put(fullUrl, { data:data })
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const generarDocumentosFC_34 = createAsyncThunk(
    GENERAR_OFICIOS_FC34_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

//Para guardar la información del modal en atención a clientes
export const actualizarFC_34SolicitudModal = createAsyncThunk(
    ACTUALIZAR_FC_34_SOLICITUD_MODAL_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data } 
            const actualizarFC_34 = host + `FC_34/actualizarFormatoFC34`
            const res = await axios.put(actualizarFC_34, solicitud)
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const fc34Slice = createSlice({
    name: 'fc34Slice',
    initialState: dataInicial,
    reducers: {
        actualizarPaginaActivaFC_34(state, { payload }) {
            state.paginaActiva = payload
        },
        guardarCambiosFC_34Solicitud(state, { payload }) {
            state.fc_34 = payload
        },
        resetDataFC_34(state, { payload }) {
            return dataInicial
        },
        setModoVerDetalleFC_34(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_34(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoProcesoFC_34(state, { payload }) {
            state.modoProceso = payload
        },
    },
    extraReducers: {
        [agregarMapFC_34Accion.fulfilled]: (state, { payload }) => {

        },
        [actualizarFC_34Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_34SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_34Map.fulfilled]: (state, { payload }) => {
            state.fc_34Map = payload
        },
        [actualizarFC_34Solicitud.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_34MapSolicitud.fulfilled]: (state, { payload }) => {
        },
    },
})

//actions
export const {
    actualizarPaginaActivaFC_34,
    guardarCambiosFC_34Solicitud,
    resetDataFC_34,
    setModoVerDetalleFC_34, setModoRecibidasCorregidasFC_34, setModoProcesoFC_34
} = fc34Slice.actions

export const FC34ReducerAtencionACliente = fc34Slice.reducer